import { z } from "zod";
export class Ok {
    value;
    constructor(value){
        this.value = value;
    }
    isOk() {
        return true;
    }
    isErr() {
        return false;
    }
    toStatus() {
        return {
            status: "ok",
            value: this.value
        };
    }
}
export class Err {
    error;
    constructor(error){
        this.error = error;
    }
    isOk() {
        return false;
    }
    isErr() {
        return true;
    }
    asAnyValueError() {
        return this;
    }
    toStatus() {
        return {
            status: "error",
            error: this.error
        };
    }
}
export class SWResultPromise extends Promise {
    constructor(...args){
        super(...args);
    }
    async isOk() {
        return this.then((result)=>result.isOk());
    }
    async isErr() {
        return this.then((result)=>result.isErr());
    }
    async toStatus() {
        return this.then((result)=>result.toStatus());
    }
}
/**
 * Construct a new Ok result value.
 */ export const ok = (value)=>new Ok(value);
/**
 * Construct a new Ok Promise result value.
 */ export const okPromise = (value)=>new SWResultPromise((resolve)=>resolve(ok(value)));
/**
 * Construct a new Err result value.
 */ export const err = (error)=>new Err(error);
export const errUknown = (error)=>new Err(error instanceof Error ? error : new Error("Unknown error"));
/**
 * Construct a new Err Promise result value.
 */ export const errPromise = (error)=>new SWResultPromise((resolve)=>resolve(err(error)));
/**
 *
 * @param status The status to convert to a result
 * @returns A result from the status
 */ export const resultFromStatus = (status)=>{
    if (status.status === "ok") {
        return ok(status.value);
    } else {
        return err(status.error);
    }
};
// https://dev.to/duunitori/mimicing-rust-s-result-type-in-typescript-3pn1
export const buildResultStatusSchema = ({ value, error: _error })=>{
    let error = _error || z.string();
    return z.discriminatedUnion("status", [
        z.object({
            status: z.literal("ok"),
            value
        }),
        z.object({
            status: z.literal("error"),
            error
        })
    ]);
};
